import {useTranslations} from 'next-intl';
import {Row, Col} from '@/grid';
import Container from '@/container';
import BoxGrid from '@/ui/box-grid';
import {GridItem, GridLayout} from '@/ui/grid/grid-layout';
import {H4, P, PNoMargin} from '@/typography';
import {withHeadingEyebrow} from '@/hocs/withFontType';
import {withPurple500} from '@/hocs/withColors';
import {withMarginBottomXs} from '@/hocs/withSpacing';
import {SectionSpacedTopLgToDouble} from '@/section';
import type {AgentDeliversCard} from '@/content/workable-ai/types';
import {BgNeutral200Div, Grid, H2MarginedMd, TitleBlock} from '@/content/workable-ai/shared';
import styles from './agent-delivers-section.module.scss';

const H4MarginedXs = withMarginBottomXs(H4 as never);
const EyebrowPurple500 = withPurple500(withHeadingEyebrow(P as never));

const AgentDeliversSection = () => {
  const t = useTranslations('workableAi.agentDelivers');
  const cards = t.raw('cards') as AgentDeliversCard[];

  return (
    <BgNeutral200Div>
      <SectionSpacedTopLgToDouble>
        <Container>
          <Grid fluid>
            <Row center="xs">
              <Col xs={12} md={10}>
                <EyebrowPurple500>{t('eyebrow')}</EyebrowPurple500>
                <H2MarginedMd>{t('title')}</H2MarginedMd>
                <TitleBlock>
                  <PNoMargin>{t('subtitle')}</PNoMargin>
                </TitleBlock>
              </Col>
            </Row>

            <div className={styles['cards-grid']}>
              <GridLayout Col={4} lgCol={2} autoRows>
                {cards.map(({id, title, body}) => (
                  <GridItem key={id}>
                    <BoxGrid backgroundColor="var(--neutral50)">
                      <H4MarginedXs>{title}</H4MarginedXs>
                      <PNoMargin>{body}</PNoMargin>
                    </BoxGrid>
                  </GridItem>
                ))}
              </GridLayout>
            </div>

            {/* <Row center="xs">
              <Col xs={12}>
                <Link
                  href="/demo"
                  className={styles['animation-link']}
                  customAttributes={{
                    'data-gtm': 'ai-agent-animated-banner-demo',
                    'data-ui': 'ai-agent-animated-banner-demo'
                  }}>
                  <div className={styles['animation-block']}>
                    <PictureWrapper
                      imgPath={IMG_BASE}
                      imageUrl="agent-logo"
                      imageTypeFallback="png"
                      altImage={t('animationLogoAlt')}
                      width={88}
                      height={88}
                    />
                    <H3MarginedSm className="heading-4">{t('animationTitle')}</H3MarginedSm>
                    <img
                      src={`${IMG_BASE}Agent-input-field-animation.svg?v=${assetV}`}
                      width={666}
                      height={147}
                      alt={t('animationFieldAlt')}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </Link>
              </Col>
            </Row> */}
          </Grid>
        </Container>
      </SectionSpacedTopLgToDouble>
    </BgNeutral200Div>
  );
};

export default AgentDeliversSection;
